package pl.decks.chartjs.radar.builder

import pl.decks.chartjs.radar.options.plugins.TooltipCallbacks

@Suppress("unused")
@RadarDsl
class TooltipCallbacksScope {
    private var title: ((Array<dynamic>) -> String)? = null
    private var label: ((dynamic) -> String)? = null
    private var beforeBody: ((Array<dynamic>) -> String)? = null
    private var afterBody: ((Array<dynamic>) -> String)? = null

    fun title(block: (items: Array<dynamic>) -> String) { title = block }
    fun label(block: (item: dynamic) -> String) { label = block }
    fun beforeBody(block: (items: Array<dynamic>) -> String) { beforeBody = block }
    fun afterBody(block: (items: Array<dynamic>) -> String) { afterBody = block }

    internal fun build() = TooltipCallbacks(
        title = title,
        label = label,
        beforeBody = beforeBody,
        afterBody = afterBody,
    )
}
